import { FC } from 'react';
import { FieldRenderProps } from 'react-final-form';

import AvatarUpload, { AvatarUploadVariant, UploadAvatarData } from '../../AvatarUpload';
import FormHelperText from '../FormHelperText';

import UserAvatarInputWrapper from './Wrapper';

export type UserAvatarInputProps = FieldRenderProps<UploadAvatarData, HTMLDivElement> & {
  label?: string;
  variant?: AvatarUploadVariant;
};

export const isUploadAvatarData = (value: UploadAvatarData | string): value is UploadAvatarData =>
  !!(value as UploadAvatarData).objectUrl;

const UserAvatarInput: FC<UserAvatarInputProps> = ({
  input: { value, onChange },
  meta: { error, touched },
  variant
}) => (
  <UserAvatarInputWrapper>
    {touched && <FormHelperText variant="static">{error}</FormHelperText>}
    <AvatarUpload
      variant={variant}
      preview={isUploadAvatarData(value) ? value.objectUrl : value}
      onUpload={value => onChange(value)}
    />
  </UserAvatarInputWrapper>
);

export default UserAvatarInput;
